module.exports = __webpack_public_path__ + "img/1556450792.b18cf6aa.jpg";